import Geocode from 'react-geocode';

import { getIsoCodeCurrentLocale } from 'common/utils/helpers/multiregion';

import {
    FETCH_GEOCODE,
    FETCH_GEOCODE_ERROR,
    FETCH_GEOCODE_SUCCESS,
} from '../actionTypes';
import { locationFormActions } from '../reducer';

export default (str, name) => (dispatch) => {
    if (!str) return;

    Geocode.setApiKey(import.meta.env.VITE_GOOGLE_MAPS_KEY);
    Geocode.setLanguage(getIsoCodeCurrentLocale());
    Geocode.setRegion('mx');

    dispatch(locationFormActions[FETCH_GEOCODE]({ name }));

    Geocode.fromAddress(str).then(
        (response) =>
            dispatch(
                locationFormActions[FETCH_GEOCODE_SUCCESS]({
                    name,
                    payload: response.results,
                }),
            ),
        (error) =>
            dispatch(
                locationFormActions[FETCH_GEOCODE_ERROR]({
                    name,
                    payload: error,
                }),
            ),
    );
};
